import { FALL_ACTIVITY_COUNT } from "./fallBingoData";

export const FALL_BINGO_LOGO = `${process.env.PUBLIC_URL}/img/fall-bingo/mcc-logo-black.png`;
export const FALL_BINGO_CHARACTERS = {
  female: `${process.env.PUBLIC_URL}/img/fall-bingo/female.png`,
  male: `${process.env.PUBLIC_URL}/img/fall-bingo/male.png`,
};

function loadPrizeImage(src) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error("Your badge artwork could not be loaded. Please try again."));
    image.src = src;
  });
}

// Render locally with artwork served by the app, so downloading needs no external service.
export async function renderFallBingoPrize(name, season, completedAt, gender = "female") {
  const [logo, character] = await Promise.all([
    loadPrizeImage(FALL_BINGO_LOGO),
    loadPrizeImage(FALL_BINGO_CHARACTERS[gender] || FALL_BINGO_CHARACTERS.female),
  ]);
  const canvas = document.createElement("canvas");
  canvas.width = 1200;
  canvas.height = 1200;
  const ctx = canvas.getContext("2d");
  if (!ctx) throw new Error("Image downloads are unavailable in this browser.");
  const background = ctx.createLinearGradient(0, 0, 1200, 1200);
  background.addColorStop(0, "#fff7e9");
  background.addColorStop(1, "#f2d8ac");
  ctx.fillStyle = background;
  ctx.fillRect(0, 0, 1200, 1200);
  ctx.strokeStyle = "#a64d2e";
  ctx.lineWidth = 3;
  ctx.strokeRect(42, 42, 1116, 1116);
  ctx.strokeRect(56, 56, 1088, 1088);
  ctx.textAlign = "center";
  ctx.fillStyle = "#723b27";
  const logoWidth = 310;
  const logoHeight = logoWidth * logo.naturalHeight / logo.naturalWidth;
  ctx.drawImage(logo, (canvas.width - logoWidth) / 2, 142 - logoHeight / 2, logoWidth, logoHeight);
  ctx.font = "24px sans-serif";
  ctx.fillText(`${season.toUpperCase()} · BINGO COLLECTION`, 600, 238);

  const characterScale = Math.min(440 / character.naturalWidth, 390 / character.naturalHeight);
  const characterWidth = character.naturalWidth * characterScale;
  const characterHeight = character.naturalHeight * characterScale;
  ctx.drawImage(character, 600 - characterWidth / 2, 258 + (390 - characterHeight) / 2, characterWidth, characterHeight);
  ctx.fillStyle = "#4b3022";
  ctx.font = "bold 66px Georgia, serif";
  ctx.fillText("Fall Adventure", 600, 690);
  ctx.fillText("Champion", 600, 768);
  ctx.font = "52px Georgia, serif";
  const displayName = name.trim().slice(0, 80) || "Fall adventurer";
  ctx.fillText(displayName, 600, 854, 960);
  ctx.fillStyle = "#723b27";
  ctx.font = "26px sans-serif";
  ctx.fillText(`${FALL_ACTIVITY_COUNT} little adventures. One unforgettable season.`, 600, 928);
  ctx.font = "22px sans-serif";
  const date = new Date(completedAt).toLocaleDateString("en-CA", { month: "long", day: "numeric", year: "numeric" });
  ctx.fillText(`Full card completed · ${date}`, 600, 1030);
  return canvas;
}

export async function createFallBingoPrizeFile(name, season, completedAt, gender = "female") {
  const canvas = await renderFallBingoPrize(name, season, completedAt, gender);
  const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/png"));
  if (!blob) throw new Error("Your badge could not be created. Please try again.");
  return new File([blob], "my-challenge-canada-fall-bingo-champion-2026.png", { type: "image/png" });
}

export function downloadFallBingoPrizeFile(file) {
  const url = URL.createObjectURL(file);
  const link = document.createElement("a");
  link.href = url;
  link.download = file.name;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 10000);
}

export async function downloadFallBingoPrize(name, season, completedAt, gender = "female") {
  downloadFallBingoPrizeFile(await createFallBingoPrizeFile(name, season, completedAt, gender));
}
